import React from "react";
import "./home-styles.css";
import ItemDetailsFooter from "../item-details/components/item-details-footer";
const Home = () => {
  return (
    <div className="home-container">
      <p className="home-logo-container">
        <img src={require("../../assets/images/logo.png")} alt="logo" />
      </p>
      <div className="home-content-container">
        <p>
          <strong>IOU Hub – Simple Debt Tracking for Everyone</strong>
        </p>
        <p>
          Whether you're splitting bills with friends or managing customer tabs,
          IOU Hub makes it easy to track what’s owed and by whom. Record
          transactions, add images, set due dates, and stay organized.
        </p>

        <p>
          <strong>Choose Your Account Type</strong>
        </p>
        <ul>
          <li>
            <strong>Personal Account:</strong> Perfect for everyday users who
            want to manage lending and borrowing with friends, family, or
            anyone. Free and Pro plans available.
          </li>
          <li>
            <strong>Business Account:</strong> Ideal for vendors and service
            providers. Includes customer check-ins, reward programs, and all
            personal features.
          </li>
        </ul>

        <p>
          <strong>Why IOU Hub?</strong>
        </p>
        <ul>
          <li>Create IOUs for money, goods, or services</li>
          <li>Attach receipts or payment images</li>
          <li>Built-in chat for real-time updates</li>
          <li>Reminders and recurring IOUs (Pro only)</li>
          <li>QR code scanner for easy sharing and check-ins</li>
          <li>Export data and manage history</li>
        </ul>

        <p>
          <strong>Power Up Your Business</strong>
        </p>
        <ul>
          <li>
            <strong>Check-In Feature:</strong> Let users scan to connect and
            track IOUs during visits
          </li>
          <li>
            <strong>Rewards System:</strong> Offer points and prizes for timely
            IOU settlements
          </li>
        </ul>

        <p>
          <strong>Start tracking smarter today!</strong>
        </p>

        <ItemDetailsFooter />
      </div>
    </div>
  );
};

export default Home;
